import React from 'react';

const InfoIcon: React.FC = () => {
  return (
    <svg
      width="8"
      height="8"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00001 7.33333C8.3682 7.33333 8.66667 7.63181 8.66667 8V10.6667C8.66667 11.0349 8.3682 11.3333 8.00001 11.3333C7.63181 11.3333 7.33334 11.0349 7.33334 10.6667V8C7.33334 7.63181 7.63181 7.33333 8.00001 7.33333Z"
        fill="currentColor"
      />
      <path
        d="M8.00001 6C8.3682 6 8.66667 5.70152 8.66667 5.33333C8.66667 4.96515 8.3682 4.66667 8.00001 4.66667C7.63181 4.66667 7.33334 4.96515 7.33334 5.33333C7.33334 5.70152 7.63181 6 8.00001 6Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.666672 8C0.666672 3.94991 3.94992 0.666668 8.00001 0.666668C12.0501 0.666668 15.3333 3.94991 15.3333 8C15.3333 12.0501 12.0501 15.3333 8.00001 15.3333C3.94992 15.3333 0.666672 12.0501 0.666672 8ZM8.00001 2C4.6863 2 2.00001 4.68629 2.00001 8C2.00001 11.3137 4.6863 14 8.00001 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8.00001 2Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default InfoIcon;
